import React, { memo } from 'react';
import PropTypes from 'prop-types';
import {
  Form,
  Common18NextProvider,
} from 'lidya-common-components';
import i18n from '../../common/i18n';
import { FormFields } from './sign.up.form.fields.container';

export const POSSIBLE_FORMS = {
  NEWSLETTER: 'newsletter',
  SIGN_UP: 'sign_up',
  INVESTORS: 'investors',
};

export const initvalues = {
  firstName: '',
  lastName: '',
  email: '',
  telephone: '',
  rEmail: '',
  agreeTerms: false,
};

export const SignUpFormMemo = memo(
  ({
    onSubmit, submitLabel, noRetypeEmail,
  }) => (
    <Common18NextProvider i18n={i18n}>
      <Form
        id="SignUpForm"
        initialValues={initvalues}
        hideSubmitIcon
        onSubmit={onSubmit}
        submitLabel={submitLabel}
        hideErrorModal
        hideCancel
        withContext
      >
        <FormFields noRetypeEmail={noRetypeEmail} />
      </Form>
    </Common18NextProvider>
  ),
);

SignUpFormMemo.propTypes = {
  onSubmit: PropTypes.func.isRequired,
  submitLabel: PropTypes.string,
  noRetypeEmail: PropTypes.bool,
};

SignUpFormMemo.defaultProps = {
  submitLabel: undefined,
  noRetypeEmail: undefined,
};

export default SignUpFormMemo;
